var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666504 5.30283C0.666504 3.43558 2.18021 1.92188 4.04746 1.92188H13.9522C15.8195 1.92188 17.3332 3.43558 17.3332 5.30283V15.2076C17.3332 17.0748 15.8195 18.5885 13.9522 18.5885H4.04746C2.18021 18.5885 0.666504 17.0748 0.666504 15.2076V5.30283ZM4.04746 3.35045C2.96919 3.35045 2.09508 4.22456 2.09508 5.30283V15.2076C2.09508 16.2859 2.96919 17.16 4.04746 17.16H13.9522C15.0305 17.16 15.9046 16.2859 15.9046 15.2076V5.30283C15.9046 4.22456 15.0305 3.35045 13.9522 3.35045H4.04746Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73479 0.832031C6.12928 0.832031 6.44908 1.15183 6.44908 1.54632V3.72319C6.44908 4.11768 6.12928 4.43747 5.73479 4.43747C5.3403 4.43747 5.02051 4.11768 5.02051 3.72319V1.54632C5.02051 1.15183 5.3403 0.832031 5.73479 0.832031Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2651 0.832031C12.6596 0.832031 12.9794 1.15183 12.9794 1.54632V3.72319C12.9794 4.11768 12.6596 4.43747 12.2651 4.43747C11.8706 4.43747 11.5508 4.11768 11.5508 3.72319V1.54632C11.5508 1.15183 11.8706 0.832031 12.2651 0.832031Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09508 9.16406C2.09508 12.0758 4.45548 14.4362 7.36719 14.4362H16.0747C16.4692 14.4362 16.789 14.756 16.789 15.1505C16.789 15.5449 16.4692 15.8647 16.0747 15.8647H7.36719C3.66651 15.8647 0.666504 12.8647 0.666504 9.16406H2.09508Z",
    fill: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.47559 7.32757C4.47559 6.93308 4.79538 6.61328 5.18987 6.61328H5.66606C6.06055 6.61328 6.38035 6.93308 6.38035 7.32757C6.38035 7.72206 6.06055 8.04185 5.66606 8.04185H5.18987C4.79538 8.04185 4.47559 7.72206 4.47559 7.32757Z",
    fill: "#666666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28564 7.32757C8.28564 6.93308 8.60544 6.61328 8.99993 6.61328H9.47612C9.87061 6.61328 10.1904 6.93308 10.1904 7.32757C10.1904 7.72206 9.87061 8.04185 9.47612 8.04185H8.99993C8.60544 8.04185 8.28564 7.72206 8.28564 7.32757Z",
    fill: "#666666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0952 7.32757C12.0952 6.93308 12.415 6.61328 12.8095 6.61328H13.2857C13.6802 6.61328 14 6.93308 14 7.32757C14 7.72206 13.6802 8.04185 13.2857 8.04185H12.8095C12.415 8.04185 12.0952 7.72206 12.0952 7.32757Z",
    fill: "#666666"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.47559 11.1401C4.47559 10.7456 4.79538 10.4258 5.18987 10.4258H5.66606C6.06055 10.4258 6.38035 10.7456 6.38035 11.1401C6.38035 11.5346 6.06055 11.8544 5.66606 11.8544H5.18987C4.79538 11.8544 4.47559 11.5346 4.47559 11.1401Z",
    fill: "#666666"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28564 11.1401C8.28564 10.7456 8.60544 10.4258 8.99993 10.4258H9.47612C9.87061 10.4258 10.1904 10.7456 10.1904 11.1401C10.1904 11.5346 9.87061 11.8544 9.47612 11.8544H8.99993C8.60544 11.8544 8.28564 11.5346 8.28564 11.1401Z",
    fill: "#666666"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0952 11.1401C12.0952 10.7456 12.415 10.4258 12.8095 10.4258H13.2857C13.6802 10.4258 14 10.7456 14 11.1401C14 11.5346 13.6802 11.8544 13.2857 11.8544H12.8095C12.415 11.8544 12.0952 11.5346 12.0952 11.1401Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGrey);
export default __webpack_public_path__ + "static/media/calendar_grey.29eee6f7.svg";
export { ForwardRef as ReactComponent };